const track = (eventName, properties) => {
  window?.analytics?.track(eventName, properties);
};
export default track;
